export const environment = {
  production: true,
  allowProviderEmailRecipients: false,
  drcfSigningEnabled: true,
  apiUrl: 'https://qa-webapi-bcf9dbd9b5bkfra4.centralus-01.azurewebsites.net/api', // Replace with your backend's local address and port
  msalConfig: {
    auth: {
      clientId: '69b1f1d6-cd6b-4159-b3a1-587dcefb67c9',// 'Application (client) ID' of app registration in Azure portal - this value is a GUID
      authority: "https://MatrixPPA.b2clogin.com/MatrixPPA.onmicrosoft.com/B2C_1_DEV_PPA",
      redirectURL: '/auth',
      scopes: ['openid','offline_access'],
      apiScope: 'https://MatrixPPA.onmicrosoft.com/api://f1afb745-9ecb-4cd9-a535-8b848fef7bc1/API.USE',
      authorityDomain: 'MatrixPPA.b2clogin.com',
    },
  },
  apiConfig: {
    scopes: ['API.USE'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
};
